import React from "react";
import { Flex } from "@ugc-ui/lego";
import { SkeletonBlock } from "@admin/pages/ShowCampaign/ShowCampaign.styled";
import { Spacer } from "@common/components/Statistic/ChartCustomTooltip.styled";

export const StatisticTouchSkeletonPage = () => {
  const chart = (
    <Flex alignItems="flex-end" justifyContent="space-between">
      <SkeletonBlock height={120} width={8} />
      <SkeletonBlock height={90} width={8} />
      <SkeletonBlock height={94} width={8} />
      <SkeletonBlock height={100} width={8} />
      <SkeletonBlock height={110} width={8} />
      <SkeletonBlock height={100} width={8} />
      <SkeletonBlock height={110} width={8} />
      <SkeletonBlock height={80} width={8} />
      <SkeletonBlock height={62} width={8} />
      <SkeletonBlock height={90} width={8} />
      <SkeletonBlock height={100} width={8} />
      <SkeletonBlock height={110} width={8} />
      <SkeletonBlock height={115} width={8} />
      <SkeletonBlock height={120} width={8} />
      <SkeletonBlock height={80} width={8} />
      <SkeletonBlock height={94} width={8} />
      <SkeletonBlock height={50} width={8} />
      <SkeletonBlock height={110} width={8} />
      <SkeletonBlock height={90} width={8} />
      <SkeletonBlock height={80} width={8} />
      <SkeletonBlock height={70} width={8} />
      <SkeletonBlock height={62} width={8} />
      <SkeletonBlock height={40} width={8} />
      <SkeletonBlock height={90} width={8} />
      <SkeletonBlock height={100} width={8} />
      <SkeletonBlock height={120} width={8} />
    </Flex>
  );

  const chartHeader = (
    <Flex justifyContent="space-between">
      <SkeletonBlock height={8} width={159} />
      <SkeletonBlock height={8} width={57} />
    </Flex>
  );
  return (
    <Flex flexDirection="column" gap={32}>
      {/* верх */}
      <SkeletonBlock height={8} width={159} />
      <Flex justifyContent="space-between">
        <Flex gap={8} flexDirection="column">
          <SkeletonBlock height={8} width={57} />
          <SkeletonBlock height={8} width={87} />
        </Flex>
        <Flex gap={8} flexDirection="column">
          <SkeletonBlock height={8} width={57} />
          <SkeletonBlock height={8} width={87} />
        </Flex>
        <Flex gap={8} flexDirection="column">
          <SkeletonBlock height={8} width={57} />
          <SkeletonBlock height={8} width={87} />
        </Flex>
      </Flex>
      <Spacer />
      {/* графики */}
      {chartHeader}
      {chart}
      <Spacer />
      {chartHeader}
      {chart}
      <Spacer />
      {chartHeader}
      {chart}
      <Spacer />
    </Flex>
  );
};
